import { EventService } from 'px-business-components';

const eventsBasePath = process.env.VUE_APP_API_URL_EVENTS;
const eventsOrigin = process.env.VUE_APP_EVENTS_ORIGIN;
const enabled = process.env.VUE_APP_EVENTS_ENABLED !== 'false';

const Event = EventService.createEventsInstance(eventsBasePath, eventsOrigin, enabled);
export default Event;
